import Vue from 'vue'
import VueRouter from 'vue-router'
import mLayout from '@/module/layout'
import users from './users'
import jump from './jump'
import cs from './cs'

Vue.use(VueRouter)

export const basicsRouterMap = [
  {
    path: '/',
    meta: {
      title: '/',
      auth: true
    }
  },
  {
    path: '/app-redirect',
    component: mLayout,
    meta: {
      title: 'redirect',
      auth: true
    },
    children: [
      {
        path: '/app-redirect/:path*',
        meta: {
          title: 'redirect',
          auth: true
        },
        component: () => import('@/conf/home/pages/redirect/index')
      }
    ]
  },
  {
    path: '/app-login',
    meta: { title: '登录', auth: true },
    component: () => import('@/conf/home/pages/login/index')
  },
  {
    path: '/app-check',
    meta: { title: '激活账号', auth: true },
    component: () => import('@/conf/home/pages/login/check')
  },
  {
    path: '/auth-redirect',
    meta: { title: 'redirect', auth: true },
    component: () => import('@/conf/home/pages/login/authredirect')
  },
  {
    path: '/app-error401',
    name: '401',
    meta: { title: '无权限', auth: true },
    component: () => import('@/conf/home/pages/error/401')
  },
  {
    path: '/app-error404',
    name: '404',
    meta: { title: '找不到该页面', auth: true },
    component: () => import('@/conf/home/pages/error/404')
  },
  {
    path: '/home',
    name: '首页',
    meta: { title: '首页' },
    component: () => import('@/conf/home/pages/home')
  }
]

export const extendRouterMap = [
  users,
  jump,
  cs
]

export const routes = [...basicsRouterMap, ...extendRouterMap]

// 创建 路由 对象
const createRouter = () =>
  new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes
  })

const router = createRouter()

export default router



// WEBPACK FOOTER //
// ./src/js/conf/home/router/index.js